//`http://localhost:1234`; //dev
// `https://app-ttj.sisc.ro`; //live

// export const API_URL = `http://localhost:4231`; //dev
// export const API_URL = `https://test3.sisc.ro`; // testing
export const API_URL = `https://app-ttj.sisc.ro`; //live

// export const API_URL =
// 	process.env.NODE_ENV === 'development'
// 		? 'http://localhost:1234'
// 		: 'https://app-ttj.sisc.ro';



export const feedbackFilterOptions = [
  { column: "id", value: "ID" },
  { column: "emailIntervievat", value: "Email Intervievat" },
  { column: "numeIntervievat", value: "Nume Intervievat" },
  { column: "numeObservator", value: "Nume Observator" },
  { column: "numeIntervievator", value: "Nume Intervievator" },
  { column: "notaExperienta", value: "Nota Experienta" },
  { column: "notaSoftSkills", value: "Nota Soft Skills" },
  { column: "notaHardSkills", value: "Nota Hard Skills" },
  { column: "notaLingvistic", value: "Nota Lingvistic" },
  { column: "notaTotal", value: "Nota Total" },
  { column: "optiunea1", value: "Optiunea 1" },
  { column: "optiunea2", value: "Optiunea 2" },
  { column: "optiunea3", value: "Optiunea 3" },
  { column: "observatii", value: "Observatii" }
];



export const rowsToDisplay = [
  { rows: 6 },
  { rows: 10 },
  { rows: 15 },
  { rows: 30 },
  { rows: 60 },
  { rows: 100 }
];


export const parteneri = ["Ubisoft", "BCR", "EY"];

export const tipTest = [
  {
    tip: "Multiple Choice",
    value: true
  },
  {
    tip: "Open Answer",
    value: false
  }
];

export let nrIntrebari = [];

for (let i = 3; i <= 25; i++) {
  nrIntrebari.push(i);
}

export const nrRaspunsuri = [3, 4, 5, 6];

export class Intrebare {
  nrIntrebare = 0;
  text = "";
  nrRaspunsuri = 0;
  punctaj = 0;
  raspunsuri = [];

  constructor(nrIntrebare, text, nrRaspunsuri, punctaj, raspunsuri) {
    this.nrIntrebare = nrIntrebare;
    this.text = text;
    this.nrRaspunsuri = nrRaspunsuri;
    this.punctaj = punctaj;
    this.raspunsuri = raspunsuri;
  }
}

export class Raspuns {
  text = "";
  esteCorect = false;

  constructor(text, esteCorect) {
    this.text = text;
    this.esteCorect = esteCorect;
  }
}
